import { TermsServiceHeroInner } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { JSX } from 'react';
import styles from './termsOfServiceHero.module.scss';

export type TermsServiceHeroProps =
  SliceComponentProps<Content.TermsServiceHeroSlice>;

const TermsServiceHero = ({ slice }: TermsServiceHeroProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
      className={styles.hero}
    >
      <TermsServiceHeroInner data={slice.primary} />
    </section>
  );
};

export default TermsServiceHero;
